/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EffectivePortfolioSource = {
    StoreAssignment: 'STORE_ASSIGNMENT',
    RetailerAssignment: 'RETAILER_ASSIGNMENT',
    Unrestricted: 'UNRESTRICTED',
    SupplierUnavailable: 'SUPPLIER_UNAVAILABLE'
} as const;
export type EffectivePortfolioSource = typeof EffectivePortfolioSource[keyof typeof EffectivePortfolioSource];


// @ts-ignore
export function EffectivePortfolioSourceFromJSON(json: any): EffectivePortfolioSource {
    return EffectivePortfolioSourceFromJSONTyped(json, false);
}

// @ts-ignore
export function EffectivePortfolioSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): EffectivePortfolioSource {
    return json as EffectivePortfolioSource;
}

// @ts-ignore
export function EffectivePortfolioSourceToJSON(value?: EffectivePortfolioSource | null): any {
    return value as any;
}

